import { buildPath } from "../../../helpers/string";
import { PermissionEnum } from "../../../modules/permission/enum";
import { root } from "./root";

export const compliance = {
  path: "compliance",
  getLink: () => buildPath([root.path, compliance.path]),
  permissions: [PermissionEnum.DOCUMENT_MANAGEMENT_ACCESS],
  attachmentGroup: {
    path: ":attachmentGroupId",
    getLink: (attachmentGroupId: string | number) => buildPath([compliance.getLink(), attachmentGroupId.toString()]),
    permissions: [PermissionEnum.DOCUMENT_MANAGEMENT_ACCESS],
  },
};
